import React from 'react'
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import { useState, useMemo } from "react";

function PatientList() {

    const tableStyle = `
        .ag-header-cell-resize::after{
                background-color: #1991eb52;
            }
    
        .ag-header, .ag-advanced-filter-header{
                background-color: white;
        }
    
      
    
        .ag-ltr .ag-cell{
              
                text-align: center;
                display: flex;
                // justify-content: center;
                align-items: center;
        }
    
        .ag-header{
            border: 1px solid #e2e2e2;
            box-shadow: 1px 1px 5px -4px;
            margin-bottom: 1rem;   
            background-color: #F4F5F7;  
        padding: 0.5rem 0;
        box-sizing: border-box;        
            min-height: 56px !important;
        }
    
        .ag-root-wrapper{
          border: unset;
          background: transparent
        }
    
        .ag-body-viewport{
          border: 1px solid #8080801a;
          border-top-left-radius: 5px !important;
          border-top-right-radius: 5px !important;
          background-color: white;
          box-shadow: 1px 1px 5px -2px;
        }
    
        .ag-theme-quartz .ag-header-cell-filter-button{
        display: none;}
    
    .ag-ltr .ag-header-cell-resize{
        }
    
         .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
            font-size: .9rem;
         }
    
         .ag-body-horizontal-scroll{
            height: 5px !important;
        max-height: 5px !important;
        min-height: 5px !important;
         }
    
         .ag-body-horizontal-scroll-viewport{
            height: 5px !important;
        max-height: 5px !important;
        min-height: 5px !important;
         }
    
        .ag-row{
          border-bottom: 1px solid #8cc8f575;
        }
    
    
    .ag-root ::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
    }
    
    .ag-root ::-webkit-scrollbar
    {
        width: 5px;
        background-color: #F5F5F5;
    }
    
    .ag-root ::-webkit-scrollbar-thumb
    {
        background-color: #80808070;
    }
    
    .ag-root ::-webkit-scrollbar-button {
        width: 0px;
        height: 0px;
        visibility: hidden;
    }
    
    .ag-header-cell-sortable .ag-header-cell-label{
       justify-content: center;
    }
    
      .ag-ltr .ag-cell {
            font-weight: 500 !important;
            font-size: 14px;
            letter-spacing: 0.5px;
            color: #05080B !important;
          }
    
      .ag-theme-quartz {
          --ag-odd-row-background-color: rgb(0 145 255 / 4%);
          }
    
          .odd-row {
      background-color: #f8f8fc;
    }
    
    .ag-header-cell-label{
    display: flex;
    justify-content: center;
    }
    
    .ag-paging-panel > .ag-paging-page-size .ag-wrapper {
    border: none;
    background-color: #F4F5F7
    }
    
    .ag-paging-panel{
    display: flex;
    justify-content: space-between;
    }
    
    .ag-paging-row-summary-panel{
    display: none;
    }
    
    .ag-ltr .ag-cell {
        display: flex;
        justify-content: center;
    }
    
            `;

    const [paginationPageSize, setPaginationPageSize] = useState(20);

    const autoSizeStrategy = {
        type: "fitGridWidth",
        columnLimits: [
            {
                colId: "No of Team Members",
                minWidth: 900,
            },
        ],
    };

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            filter: true,
        };
    }, []);

    const rowSelection = {
        mode: "multiRow",
        headerCheckbox: true,
    };


    const [rowData, setRowData] = useState([
        {
            PatientID: "#P-00012",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Rohan",
            DoctorAssgined: "Dr. Samantha",
            Disease: "Allergies & Asthma",
            Status: "Pending",
            RoomNo: "AB-002",
            Action: "",
        },

        {
            PatientID: "#P-00013",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "ravi",
            DoctorAssgined: "Dr. Rahul Jr",
            Disease: "Dental Care",
            Status: "Pending",
            RoomNo: "AB-003",
            Action: "",
        },

        {
            PatientID: "#P-00014",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Santhi",
            DoctorAssgined: "Dr. David ",
            Disease: "Sleep Problem",
            Status: "Recovered",
            RoomNo: "AB-004",
            Action: "",
        },

        {
            PatientID: "#P-00015",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Mounika",
            DoctorAssgined: "Dr. kavya",
            Disease: "Hearing Loss",
            Status: "On Recovery",
            RoomNo: "AB-005",
            Action: "",
        },

        {
            PatientID: "#P-00016",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Ashok",
            DoctorAssgined: "Dr. Samantha",
            Disease: "Diabetes",
            Status: "Recovered",
            RoomNo: "AB-006",
            Action: "",
        },

        {
            PatientID: "#P-00017",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Pranav",
            DoctorAssgined: "Dr. Jahanavi",
            Disease: "Allergies & Asthma",
            Status: "Pending",
            RoomNo: "AB-007",
            Action: "",
        },

        {
            PatientID: "#P-00018",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Deepthi",
            DoctorAssgined: "Dr. Santhoshi",
            Disease: "Dental Care",
            Status: "Pending",
            RoomNo: "AB-008",
            Action: "",
        },

        {
            PatientID: "#P-00019",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Swathi",
            DoctorAssgined: "Dr. Venkatrao",
            Disease: "Sleep Problem",
            Status: "Recovered",
            RoomNo: "AB-009",
            Action: "",
        },

        {
            PatientID: "#P-00020",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Sai Teja",
            DoctorAssgined: "Dr. Sanjay",
            Disease: "Hearing Loss",
            Status: "On Recovery",
            RoomNo: "AB-0010",
            Action: "",
        },

        {
            PatientID: "#P-00021",
            DateCheckIn: "26/02/2020, 12:42 AM",
            PatientName: "Rajesh",
            DoctorAssgined: "Dr. Samantha",
            Disease: "Diabetes",
            Status: "Recovered",
            RoomNo: "AB-0011",
            Action: "",
        },


    ]);

    const [colDefs, setColDef] = useState([
 

        {
            headerName: "PatientID",
            field: "PatientID",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
             
                return (
                    <>
                        <span
                            className="fw-semibold m-0"
                            style={{ fontSize: "14px", color: "#05080B" }}
                        >
                            {params.value}
                        </span>
                    </>
                );
            },
        },

        {
            field: "DateCheckIn",
            headerName: "Date Check In",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
             
                return (
                    <>
                        <span
                            className="fw-semibold m-0"
                            style={{ fontSize: "14px", color: "#05080B" }}
                        >
                            {params.value}
                        </span>
                    </>
                );
            },
        },

        {
            field: "PatientName",
            headerName: "Patient Name",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
             
                return (
                    <>
                        <span
                            className="fw-semibold m-0"
                            style={{ fontSize: "14px", color: "#05080B" }}
                        >
                            {params.value}
                        </span>
                    </>
                );
            },
        },

        {
            field: "DoctorAssgined",
            headerName: "Doctor Assgined",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
            
                return (
                    <>
                        <span
                            className="fw-semibold m-0"
                            style={{ fontSize: "14px", color: "#05080B" }}
                        >
                            {params.value}
                        </span>
                    </>
                );
            },
        },

        {
            field: "Disease",
            headerName: "Disease",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
             
                return (
                    <>
                        <span
                            className="fw-semibold m-0"
                            style={{ fontSize: "14px", color: "#05080B" }}
                        >
                            {params.value}
                        </span>
                    </>
                );
            },
        },

        {
            field: "RoomNo",
            headerName: "Room No",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
               
                return (
                    <>
                        <span
                            className="fw-semibold m-0"
                            style={{ fontSize: "14px", color: "#05080B" }}
                        >
                            {params.value}
                        </span>
                    </>
                );
            },
        },

        {
            field: "Status",
            headerName: "Status",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
              
                return (
                    <>
                        {params.value === "Pending" && (
                            <div className="fw-semibold m-0 d-flex align-items-center gap-2">
                                <span style={{ background: '#FFB800', height: ".7rem", width: ".7rem", borderRadius: '4rem' }}></span>
                                <span style={{ color: '#FFB800' }}>{params.value}</span>
                            </div>
                        )}

                        {params.value === "Recovered" && (
                            <div className="fw-semibold m-0 d-flex align-items-center gap-2">
                                <span style={{ background: '#2BC155', height: ".7rem", width: ".7rem", borderRadius: '4rem' }}></span>
                                <span style={{ color: '#2BC155' }}>{params.value}</span>
                            </div>
                        )}

                        {params.value === "On Recovery" && (
                            <div className="fw-semibold m-0 d-flex align-items-center gap-2">
                                <span style={{ background: '#369DC9', height: ".7rem", width: ".7rem", borderRadius: '4rem' }}></span>
                                <span style={{ color: '#369DC9' }}>{params.value}</span>
                            </div>
                        )}
                    </>
                );
            },
        },

        {
            field: "Seeing",
            headerName: "Action",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
             
                return (
                    <>
                        <div className="d-flex align-items-center justify-content-center gap-3">
                            <button
                                style={{ border: "none", background: "none", color: "#035ECF" }}

                            >
                                <i class="fa-regular fa-eye"></i>
                            </button>

                            <button
                                style={{ border: "none", background: "none", color: "#035ECF" }}
                            >
                                <i
                                    class="fa-regular fa-trash-can"
                                    style={{ color: "#F48458" }}
                                ></i>
                            </button>
                        </div>
                    </>
                );
            },
        },
    ]);

    return (
        <>
            <main style={{ width: "100%", height: '100%' }}>

                <div className="row">
                    <div className="col-12 mb-4">
                        <div className='d-flex align-items-center justify-content-between'>
                            <button className='border-0 rounded-5' style={{ background: "#000", color: '#fff', padding: '.5rem 1rem', width: '10rem' }}>+ Add Patient</button>
                            <div className='d-flex align-items-center gap-3'>
                                <div className="position-relative div-okij8ijj">
                                    <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                                    <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                                        <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                                    </div>
                                </div>
                                <button className='border-0 rounded-5 ' style={{ background: "#367588", height: "2.5rem", width: '2.5rem', color: '#fff' }}>
                                    <span><i class="fa-solid fa-gear"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className='ag-theme-quartz' style={{ height: 500 }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={colDefs}
                                defaultColDef={defaultColDef}
                                pagination={true}
                                domLayout="autoHeight"
                                rowClass={"tbl-row-sc"}
                                rowHeight={60}
                                autoSizeStrategy={autoSizeStrategy}
                                paginationPageSize={paginationPageSize}
                                rowSelection={rowSelection}
                            />
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default PatientList